import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getUser, getAdmin, secretCode } from '../api';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';

function Login() {
    const [formData, setFormData] = useState({
        netID: '',
        password: '',
        secpass: ''
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAdminCheckboxChange = (e) => {
        setIsAdmin(e.target.checked);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(isAdmin);
        console.log(formData);
    
        try {
            if (isAdmin) {
                if(!formData.netID || !formData.password) {
                    alert('Please fill in all fields.');
                    return;
                }
                formData.netID = formData.netID.trim();
                // Handle admin login
                // Redirect to admin page
                const response = await getAdmin(formData.netID, formData.password);
                if (response.status === 200) {
                    sessionStorage.setItem('isAdminAuthenticated', 'true');
                    navigate('/admin');
                } else {
                    alert('Failed to log in as admin. Please try again.');
                }
            } else {
                // Handle regular user login
                if(!formData.netID || !formData.password|| !formData.secpass) {
                    alert('Please fill in all fields.');
                    return;
                }

                formData.netID = formData.netID.trim();
                formData.secpass = formData.secpass.trim();
                const response = await getUser(formData.netID);
                if (response.status === 200) {
                    const user = response.data;
                    const isPasswordMatch = await bcrypt.compare(formData.password, user.password);
                    if (isPasswordMatch) {
                        sessionStorage.setItem('isUser', formData.netID);

                        //sessionStorage.setItem('cachedPassword', formData.password);
                        navigate(`/user/${formData.netID}`); // Redirect to User.js with netID
                    } else {
                        alert('Incorrect password. Please try again.');
                    }
                } else {
                    alert('Failed to log in. Please try again.');
                }
            }
        } catch (error) {
            console.error('Error logging in:', error);
            alert('Failed to log in. Please try again.');
        }
    };
    

    return (
        <div className="swe-backdrop h-auto min-h-screen justify-center items-center py-10">
          <div className="swe-user-card max-w-md h-fit">
            <Link to="/">
            <img src="imgs/swe_logo/SWE_Logo_Rutgers_University_4C.png" alt="SWE Logo" className="mb-10 w-20" />
            </Link>
            <h1 className="swe-title text-3xl font-semibold mb-10 text-swe-purple">Welcome back! Login to your account to join the meeting.   </h1>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="netID" className="font-medium text-gray-700">NetID</label>
                <input
                  type="text"
                  id="netID"
                  name="netID"
                  value={formData.netID}
                  onChange={handleChange}
                  className="swe-border mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="secpass" className="font-medium text-gray-700">Secret Passcode</label>
                <input
                  type="text"
                  id="secpass"
                  name="secpass"
                  value={formData.secpass}
                  onChange={handleChange}
                  className="swe-border mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="password" className="font-medium text-gray-700">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="swe-border mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="admin" className="font-medium text-gray-700">
                  <input
                    type="checkbox"
                    id="admin"
                    name="admin"
                    checked={isAdmin}
                    onChange={handleAdminCheckboxChange}
                    className="mr-2 form-checkbox text-swe-purple focus:ring-swe-purplelight"
                  />
                  Admin
                </label>
              </div>
              <button
                type="submit"
                className="swe-btn w-full py-2 px-4 font-medium center"
              >
                Login
              </button>
            </form>
            <p className="mt-4 text-md text-gray-600">
              Don't have an account? <Link to="/signup" className="text-swe-purplelight hover:text-swe-red">Sign up</Link>
            </p>
          </div>
        </div>
      );
    };
export default Login;